import { objectKeys } from "@cervval.js/common/src/tools/object.tools";

/** Apply translation dict (i18n) onto webcomponent components */
export function translateHTMLReferences<RefName extends string>(components: Record<RefName, HTMLElement>, translations: Partial<Record<RefName, string>>): void {
    for (const ref of objectKeys(translations)) {
        const component = components[ref as RefName];
        const content = translations[ref as RefName];
        if (component) {
            component.innerHTML = content ?? "";
        }
    }
}